import { appointment } from 'modules/schema';
import { normalize } from 'normalizr';

import {
  AppointmentsState,
  AppointmentTypesState,
  ChartsState,
  Entities,
  PhysiciansState,
  PracticesState,
  PracticeSuccessResponse,
} from 'types';
import { QueryConfig } from 'redux-query';

export const fetchAppointmentQuery = (appointmentId: number, token: string) => ({
  url: `book/api/appointments/${appointmentId}?token=${token}`,
  queryKey: `getPractice:${appointmentId}`,
  transform: ({ data }: PracticeSuccessResponse): Entities => normalize(data, appointment).entities,
  update: {
    appointmentTypes: (
      prev: AppointmentTypesState,
      next: AppointmentTypesState,
    ): AppointmentTypesState => ({ ...prev, ...next }),
    physicians: (prev: PhysiciansState, next: PhysiciansState): PhysiciansState => ({
      ...prev,
      ...next,
    }),
    appointments: (prev: AppointmentsState, next: AppointmentsState): AppointmentsState => ({
      ...prev,
      ...next,
    }),
    practices: (prev: PracticesState, next: PracticesState): PracticesState => ({
      ...prev,
      ...next,
    }),
    charts: (prev: ChartsState, next: ChartsState): ChartsState => ({
      ...prev,
      ...next,
    }),
  },
});

export const cancelAppointmentQuery = (appointmentId: number, token: string): QueryConfig => ({
  url: `book/api/appointments/${appointmentId}/cancel`,
  options: {
    method: 'POST',
  },
  body: {
    token,
  },
  queryKey: `getPractice:${appointmentId}`,
  transform: ({ data }: PracticeSuccessResponse): Entities => normalize(data, appointment).entities,
  update: {
    appointmentTypes: (
      prev: AppointmentTypesState,
      next: AppointmentTypesState,
    ): AppointmentTypesState => ({ ...prev, ...next }),
    physicians: (prev: PhysiciansState, next: PhysiciansState): PhysiciansState => ({
      ...prev,
      ...next,
    }),
    appointments: (prev: AppointmentsState, next: AppointmentsState): AppointmentsState => ({
      ...prev,
      ...next,
    }),
    practices: (prev: PracticesState, next: PracticesState): PracticesState => ({
      ...prev,
      ...next,
    }),
    charts: (prev: ChartsState, next: ChartsState): ChartsState => ({
      ...prev,
      ...next,
    }),
  },
});

export const confirmAppointmentQuery = (appointmentId: number, token: string): QueryConfig => ({
  url: `book/api/appointments/${appointmentId}/confirm`,
  options: {
    method: 'POST',
  },
  body: {
    token,
  },
  force: true,
  queryKey: `getPractice:${appointmentId}`,
  transform: ({ data }: PracticeSuccessResponse): Entities => normalize(data, appointment).entities,
  update: {
    appointmentTypes: (
      prev: AppointmentTypesState,
      next: AppointmentTypesState,
    ): AppointmentTypesState => ({ ...prev, ...next }),
    physicians: (prev: PhysiciansState, next: PhysiciansState): PhysiciansState => ({
      ...prev,
      ...next,
    }),
    appointments: (prev: AppointmentsState, next: AppointmentsState): AppointmentsState => ({
      ...prev,
      ...next,
    }),
    practices: (prev: PracticesState, next: PracticesState): PracticesState => ({
      ...prev,
      ...next,
    }),
    charts: (prev: ChartsState, next: ChartsState): ChartsState => ({
      ...prev,
      ...next,
    }),
  },
});
